import React from "react";

const ModulesSection = ({ modules, t }) => (
  <section className="modules anim-section home-section" id="producto">
    <div className="home-container">
      <div className="section-head">
        <h2>{t.modules.head}</h2>
        <p>{t.modules.sub}</p>
      </div>
      <div className="module-grid">
        {modules.map((module) => (
          <article className="module-card card-animated anim-card" key={module.title}>
            <div className="module-widget">
              <div>
                <h4
                  className="widget-value"
                  data-count-target={module.stat?.value}
                  data-count-suffix={module.stat?.suffix || ""}
                  data-count-decimals={module.stat?.decimals || 0}
                >
                  0
                </h4>
                <span className="widget-label">{module.stat?.label}</span>
              </div>
              <div className="module-bar">
                <span className="module-bar-fill" data-progress={module.progress} />
              </div>
            </div>
            <h3>{module.title}</h3>
            <p>{module.subtitle}</p>
            <ul>
              {module.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
            <button className="link-btn" type="button">
              {t.buttons.verMas}
            </button>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ModulesSection;
